/* Native description content contracts, independent of UI translations. */
(() => {
 'use strict';
 function ingredients(text){
  const value=String(text??''),heading=/\b(?:ingredienti|ingredients)\s*:\s*/i.exec(value);
  return heading?value.slice(heading.index+heading[0].length).trim()||null:null;
 }
 function matchesReference(paragraphs,reference){const normalize=value=>String(value??'').replace(/\s+/g,' ').trim();return typeof reference==='string'&&normalize(paragraphs.join(' '))===normalize(reference);}
 function informationalFooter(text){return /^Per ulteriori informazioni, vai al\s*sito ufficiale\s*$/i.test(String(text??'').trim());}
 function resources(document){
  const tags=new Set(['TABLE','IMG','VIDEO','IFRAME','A','UL','OL','DL','DETAILS','AUDIO','PICTURE','FIGURE','FORM','BUTTON','INPUT','SELECT','TEXTAREA','OBJECT','EMBED','SVG','CANVAS']);
  const candidates=[...document.body.querySelectorAll('*')].filter(node=>tags.has(node.tagName)||node.tagName.includes('-')||(node.tagName==='P'&&informationalFooter(node.textContent)));
  // Keep each resource's original description block, including delegated listeners
  // and surrounding text. Nested resources are moved once with that live block.
  return [...new Set(candidates.map(node=>{while(node.parentElement&&node.parentElement!==document.body)node=node.parentElement;return node;}))];
 }
 window.LiotroDescription={ingredients,matchesReference,informationalFooter,resources};
})();
